module.exports = __webpack_public_path__ + "img/home-pg3.0c67d403.png";